<template>
  <div>
		<footer class="py-lg-5 py-4">
            <div class="container">
                <div class="row">
                    <div class="col-lg-2">
                        <h3 class="wthree-logo mt-3">
                            <a href="index.html" id="logoLink1"><span class="fa fa-adjust"></span> <span>A</span>rtur</a>
                        </h3>
                    </div>
                    <div class="col-lg-7 my-lg-0 my-4">
                        <p><span class="fa mr-2 fa-map-marker"></span>Tchumene II, Matola, Mozambique</p>
                        <p class="mt-2"><span class="fa mr-2 fa-envelope"></span><a href="mailto:arthurmabilo@live.com">arthurmabilo@live.com</a>, <span class="fa ml-3 mr-2 fa-phone"></span>+258 84 6059 545</p>
                    </div>
                    <div class="col-lg-3 copy-right p-0 text-lg-right">
                    
                        <p>Siga-me nas redes sociais.</p>
                        <ul class="social_section_1info">
                            <li class="mb-2 facebook"><a target="_blank" href="https://web.facebook.com/arthurauthor.mabilo"><span class="fa fa-facebook"></span></a></li>
                            <li class="mb-2 twitter"><a target="_blank" href="https://twitter.com/SitoeNelzio"><span class="fa fa-twitter"></span></a></li>
                            <li class="linkedin"><a target="_blank" href="https://www.linkedin.com/in/arthur-walemo-347002143/"><span class="fa fa-linkedin"></span></a></li>
                            <li class="pinterest"><a target="_blank" href="https://github.com/mentorizer"><span class="fa fa-github"></span></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Footer.vue